import { CircularProgress, styled } from '@mui/material'
import { colors } from '../themes/Styles'

const StyledButtonLabelSpinner = styled(CircularProgress)(({ theme }) => ({
  height: 14,
  width: 14,
  marginRight: theme.spacing(0.5),
  color: colors.grey50,
}))

/** A spinner styled to show up to the left of a button label */
export function ButtonLabelSpinner({ className }: { className?: string }) {
  return <StyledButtonLabelSpinner size="small" className={className} />
}
